import React from 'react';

interface ThreeDotLengthIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const ThreeDotLengthIcon: React.FC<ThreeDotLengthIconProps> = ({ 
  width = 3, 
  height = 13, 
  color = '#0D0D0D' 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 3 13" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M0.416667 11.25C0.416667 11.7102 0.789763 12.0833 1.25 12.0833C1.71024 12.0833 2.08333 11.7102 2.08333 11.25C2.08333 10.7898 1.71024 10.4167 1.25 10.4167C0.789763 10.4167 0.416667 10.7898 0.416667 11.25Z" 
        fill={color}
      />
      <path 
        d="M0.416667 6.25C0.416667 6.71024 0.789763 7.08333 1.25 7.08333C1.71024 7.08333 2.08333 6.71024 2.08333 6.25C2.08333 5.78976 1.71024 5.41667 1.25 5.41667C0.789763 5.41667 0.416667 5.78976 0.416667 6.25Z" 
        fill={color}
      />
      <path 
        d="M0.416667 1.25C0.416667 1.71024 0.789763 2.08333 1.25 2.08333C1.71024 2.08333 2.08333 1.71024 2.08333 1.25C2.08333 0.789763 1.71024 0.416667 1.25 0.416667C0.789763 0.416667 0.416667 0.789763 0.416667 1.25Z" 
        fill={color}
      />
      <path 
        d="M1.66667 11.25C1.66667 11.0199 1.48012 10.8333 1.25 10.8333C1.01988 10.8333 0.833333 11.0199 0.833333 11.25C0.833333 11.4801 1.01988 11.6667 1.25 11.6667C1.48012 11.6667 1.66667 11.4801 1.66667 11.25ZM1.66667 6.25C1.66667 6.01988 1.48012 5.83333 1.25 5.83333C1.01988 5.83333 0.833333 6.01988 0.833333 6.25C0.833333 6.48012 1.01988 6.66667 1.25 6.66667C1.48012 6.66667 1.66667 6.48012 1.66667 6.25ZM1.66667 1.25C1.66667 1.01988 1.48012 0.833333 1.25 0.833333C1.01988 0.833333 0.833333 1.01988 0.833333 1.25C0.833333 1.48012 1.01988 1.66667 1.25 1.66667C1.48012 1.66667 1.66667 1.48012 1.66667 1.25ZM2.5 11.25C2.5 11.9404 1.94036 12.5 1.25 12.5C0.559644 12.5 0 11.9404 0 11.25C0 10.5596 0.559644 10 1.25 10C1.94036 10 2.5 10.5596 2.5 11.25ZM2.5 6.25C2.5 6.94036 1.94036 7.5 1.25 7.5C0.559644 7.5 0 6.94036 0 6.25C0 5.55964 0.559644 5 1.25 5C1.94036 5 2.5 5.55964 2.5 6.25ZM2.5 1.25C2.5 1.94036 1.94036 2.5 1.25 2.5C0.559644 2.5 0 1.94036 0 1.25C0 0.559644 0.559644 0 1.25 0C1.94036 0 2.5 0.559644 2.5 1.25Z" 
        fill={color}
      />
    </svg>
  );
};

export default ThreeDotLengthIcon;

